/* eslint-env browser*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PromiseState } from 'react-refetch';
import { articlesConnect } from '../../connect';
import { SearchArticles, PromiseStateContainer } from '../../components';

class Articles extends Component {
  componentDidMount() {
    window.scrollTo(0, this.articlesNode.offsetTop);
  }
  render() {
    const { title, items, articlesFetch } = this.props;

    return (
      <div ref={elem => (this.articlesNode = elem)}>
        {items
          ? <SearchArticles title={title} items={items} backUrl="/press" />
          : <PromiseStateContainer
              ps={PromiseState.race([articlesFetch])}
              onFulFillment={response =>
                <SearchArticles title={title} items={response} backUrl="/press" />}
            />}
      </div>
    );
  }
}

Articles.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string,
      fullDate: PropTypes.string.isRequired,
      description: PropTypes.string,
      thumbnail: PropTypes.string
    })
  ),
  articlesFetch: PropTypes.instanceOf(PromiseState).isRequired
};

export default articlesConnect(Articles);



// WEBPACK FOOTER //
// ./src/pages/press/containers/Articles/Articles.js